import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { SET_LOGIN, USER_DELETE, USER_DETAILS, USER_FORGOT_ONE, USER_FORGOT_TWO, USER_IP, USER_IS_ADMIN, USER_SAVE } from "./action-types";

// Login
export function setLogin({
    email,
    mdp
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isLog = false;

        axios.post(`${getDomain()}api/login`, {
            username: email,
            password: mdp
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);
                if (res.res.type == "succ") {
                    localStorage.setItem('userId', res.datas.user);
                    localStorage.setItem('userCred', res.datas.credentials);
                    localStorage.setItem('userRole', res.datas.role);
                    isLog = true;
                }

                dispatch({
                    type: SET_LOGIN,
                    payload: {
                        alert: alert,
                        isLog: isLog
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = alertIndex("log002");
                dispatch({
                    type: SET_LOGIN,
                    payload: {
                        alert: alert,
                        isLog: isLog
                    }
                })
            })
    }
}

// Est-ce que l'utilisateur est admin ?
export function isAdmin() {
    return function (dispatch) {
        let alert = tempAlWait();
        let isAdmin = false;

        axios.post(`${getDomain()}api/user/isadmin`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isAdmin = true;
                }

                dispatch({
                    type: USER_IS_ADMIN,
                    payload: {
                        alert: alert,
                        isAdmin: isAdmin
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = alertIndex("usia003");
                dispatch({
                    type: USER_IS_ADMIN,
                    payload: {
                        alert: alert,
                        isAdmin: isAdmin
                    }
                })
            })
    }
}

// Mot de passe oublié - 1
export function forgotOne({
    email
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        
        axios.post(`${getDomain()}api/user/forgot-one`, {
            email: email,
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: USER_FORGOT_ONE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("usfo1004");
                dispatch({
                    type: USER_FORGOT_ONE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Mot de passe oublié - 2
export function forgotTwo({
    email,
    code,
    mdp,
    mdpconf
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        
        axios.post(`${getDomain()}api/user/forgot-two`, {
            email: email,
            code: code,
            mdp: mdp,
            mdpconf: mdpconf
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: USER_FORGOT_TWO,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = alertIndex("usfo2006");
                dispatch({
                    type: USER_FORGOT_TWO,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Nouvel utilisateur
export function newUser({
    email,
    mdp,
    mdpconf,
    rules
}) {
    return function (dispatch) {
        let alert = tempAlWait();

        axios.post(`${getDomain()}api/user/save`, {
            email: email,
            mdp: mdp,
            mdpconf: mdpconf,
            rules: rules
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: USER_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("ussa006");
                dispatch({
                    type: USER_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Supprimer l'utilisateur
export function delUser({
    userId
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/user/delete/${userId}`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = res.res.code;

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: USER_DELETE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("ussa006");
                dispatch({
                    type: USER_DELETE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Obtenir le détail d'un utilisateur
export function getProfil({
    userId
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;
        let url = `${getDomain()}api/user/details/${userId}`;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: USER_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("usdt002")
                dispatch({
                    type: USER_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Vérification de l'ip pour la maintenance
export function getIp() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = false;
        let url = `${getDomain()}api/ip`;

        let verifAlReady = localStorage.getItem('memory');
        if (verifAlReady) {
            alert = alertIndex("ip001");
            datas = true;
            dispatch({
                type: USER_IP,
                payload: {
                    alert: alert,
                    isCo: datas
                }
            })
        } else {
            axios.post(url, {}, config)
                .then(res => {
                    res = res.data;
                    alert = alertIndex(res.res.code);
                    if (res.res.type == "succ") {
                        datas = res.datas;
                        if (datas) {
                            localStorage.setItem('memory', true);
                        } else {
                            localStorage.setItem('memory', false);
                        }
                    }
                    dispatch({
                        type: USER_IP,
                        payload: {
                            alert: alert,
                            isCo: datas
                        }
                    })
                })
                .catch(err => {
                    console.log(err);
                    alert = tempAlErr("ip002");
                    dispatch({
                        type: USER_IP,
                        payload: {
                            alert: alert,
                            isCo: datas
                        }
                    })
                })
        }
    }
}